import axios from 'axios'
import {ParamsModel} from 'src/app/modules/common/Model'
import {DeleteModel} from '../Model'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

export const FdTenure = `${API_URL}/fixed-deposit-tenure`

export const service = {
  getFdTenure: (params: ParamsModel) => {
    return axios.get(FdTenure, {params})
  },

  addFdTenure: (data: any) => {
    return axios.post(FdTenure, data)
  },

  updateFdTenure: (body: any, id: string) => {
    return axios.patch(`${FdTenure}/${id}`, body)
  },

  deleteFdTenure: (data: DeleteModel) => {
    return axios.delete(FdTenure, {data})
  },
  singleActivateFdTenure: (id: any) => {
    return axios.patch(`${FdTenure}/enable`, id)
  },

  singleDeactivateFdTenure: (id: any) => {
    return axios.patch(`${FdTenure}/disable`, id)
  },
}
